module.exports = __webpack_public_path__ + "static/img/Intelligence.851cc585.png";